import {BaseClient} from '../utils/base-client';

class MessageVariantsClient extends BaseClient {
  buildEndpoint({projectID, workspaceId}) {
    const baseUrl = workspaceId ? `api/app/workspaces/${workspaceId}` : `api/app/projects/${projectID}`;
    return `${baseUrl}/messages/variants/`;
  }

  processResponse(response) {
    return response.results;
  }
}

export default new MessageVariantsClient();
